module.exports = "/images/oculus-15.jpg";